module.exports = __webpack_public_path__ + "videos/whatsnew-scribble_cn.94f9133.mp4";